export class AddAppointmentService {
  static readonly type = '[Appointment] add appointment service';

  constructor(public service: any) {}
}

export class EditAppointmentService {
  static readonly type = '[Appointment] edit appointment service';

  constructor(public service: any) {}
}

export class RemoveAppointmentService {
  static readonly type = '[Appointment] remove appointment service';

  constructor(public service: any) {}
}

export class ClearAppointmentService {
  static readonly type = '[Appointment] clear appointment service';
}

export class AddAppointmentProduct {
  static readonly type = '[Appointment] add appointment Product';

  constructor(public product: any) {}
}

export class EditAppointmentProduct {
  static readonly type = '[Appointment] edit appointment Product';

  constructor(public service: any) {}
}

export class RemoveAppointmentProducte {
  static readonly type = '[Appointment] remove appointment Product';

  constructor(public service: any) {}
}

export class ClearAppointmentProduct {
  static readonly type = '[Appointment] clear appointment Product';
}

export class AddAppointmentSpecService {
  static readonly type = '[Appointment] add appointment spec service';

  constructor(public specService: any) {}
}

export class RemoveAppointmentSpecService {
  static readonly type = '[Appointment] add appointment spec service';

  constructor(public specService: any) {}
}

export class ClearAddAppointmentSpecService {
  static readonly type = '[Appointment] clear add appointment spec service';
}

export class AddAppointmentServiceProduct {
  static readonly type = '[Appointment] add appointment service product';

  constructor(public products: any[]) {}
}

export class AddAppointment {
  static readonly type = '[Appointment] add appointment';

  constructor(public booking: any) {}
}

export class EditAppointment {
  static readonly type = '[Appointment] edit appointment';

  constructor(public booking: any) {}
}

export class AddEmployeeAppointment {
  static readonly type = '[Appointment] add employee appointment';

  constructor(public booking: any) {}
}

export class EditEmployeeAppointment {
  static readonly type = '[Appointment] edit employee appointment';

  constructor(public booking: any) {}
}

export class SetAppointment {
  static readonly type = '[Appointment] set appointment';

  constructor(public bookingId: string) {}
}

export class SetEmployeeAppointment {
  static readonly type = '[Appointment] set employee appointment';

  constructor(public bookingId: string) {}
}

export class CompleteAppointment {
  static readonly type = '[Appointment] complete appointment';
}

export class CompleteUpdateAppointment {
  static readonly type = '[Appointment] CompleteUpdateAppointment appointment';
}

export class ClearAddEmployeeAppointment {
  static readonly type = '[Appointment] clear add employee appointment';
}

export class CalendarPosition {
  static readonly type = '[Appointment] set calendar position';
  constructor(public position: string) {}
}
export class CalendarTimeInterval {
  static readonly type = '[Appointment] set calendar interval';
  constructor(public interval: string) {}
}

export class ChangeEmployee {
  static readonly type = '[Appointment] change Employee';
  constructor(public payload: { employee: any; oldEmployee: any }) {}
}


export class GetEvents {
  static readonly type = '[Appointment] get events';
  constructor(public payload: { date: string }) {}
}

export class GetRoomEvents {
  static readonly type = '[Appointment] get room events';
  constructor(public payload: { date: string }) {}
}
export class GetOnlineEvents {
  static readonly type = '[Appointment] get online events';
  constructor(public payload: { date: string }) {}
}


export class GetCalendarEmployee {
  static readonly type = '[Appointment] get employee calendar';
  constructor(public payload: { date: string }) {}
}

export class GetRoomCalendar {
  static readonly type = '[Appointment] get room calendar';
  constructor(public payload: { date: string }) {}
}
